import type { FC, ReactNode } from 'react'

interface FileGlyphProps {
    tag: string
    color: string
}

// The paper file you throw: folded corner, three text lines and a coloured type tag.
export const FileGlyph: FC<FileGlyphProps> = ({ tag, color }): ReactNode => {
    const width = tag.length > 3 ? 28 : 24

    return (
        <svg viewBox='0 0 56 72' className='absolute inset-0 size-full overflow-visible' aria-hidden='true'>
            <path
                d='M6 0.5H42.5L55.5 13.5V66A5.5 5.5 0 0 1 50 71.5H6A5.5 5.5 0 0 1 0.5 66V6A5.5 5.5 0 0 1 6 0.5Z'
                className='fill-white stroke-crease'
            />
            <path
                d='M42.5 0.5V10A3.5 3.5 0 0 0 46 13.5H55.5Z'
                className='fill-fold stroke-crease'
                strokeLinejoin='round'
            />
            <rect x={11} y={20} width={26} height={3} rx={1.5} className='fill-paper-line' />
            <rect x={11} y={27} width={33} height={3} rx={1.5} className='fill-paper-line' />
            <rect x={11} y={34} width={21} height={3} rx={1.5} className='fill-paper-line' />
            <rect x={7} y={51} width={width} height={13} rx={3.5} style={{ fill: color }} />
            <text
                x={7 + width / 2}
                y={60.3}
                textAnchor='middle'
                fontSize={8}
                fontWeight={600}
                letterSpacing='0.04em'
                className='fill-white'
            >
                {tag}
            </text>
        </svg>
    )
}

// The small version shown on an upload row, about 24px wide.
export const MiniFileGlyph: FC<FileGlyphProps> = ({ tag, color }): ReactNode => {
    const width = tag.length > 3 ? 19 : 16

    return (
        <svg viewBox='0 0 24 30' className='h-[30px] w-[24px] shrink-0 overflow-visible' aria-hidden='true'>
            <path
                d='M3 0.5H16.5L23.5 7.5V27A2.5 2.5 0 0 1 21 29.5H3A2.5 2.5 0 0 1 0.5 27V3A2.5 2.5 0 0 1 3 0.5Z'
                className='fill-white stroke-crease'
            />
            <path
                d='M16.5 0.5V5.5A2 2 0 0 0 18.5 7.5H23.5Z'
                className='fill-fold stroke-crease'
                strokeLinejoin='round'
            />
            <rect x={-2.5} y={16.5} width={width} height={8.5} rx={2} style={{ fill: color }} />
            <text
                x={-2.5 + width / 2}
                y={22.8}
                textAnchor='middle'
                fontSize={5.6}
                fontWeight={600}
                letterSpacing='0.02em'
                className='fill-white'
            >
                {tag}
            </text>
        </svg>
    )
}
